import React from 'react';
import { PageWithAuthorization } from '@homeproved/shared/feature-auth';
import { PageShell } from '@homeproved/com/feature-page-shell';
import { VacaturesPage } from '@homeproved/com/feature-vacatures';
import { apiFactory, getDehydratedState, JobsApiFactory } from '@homeproved/shared/data-access';

export const Index: PageWithAuthorization = () => (
  <PageShell>
    <VacaturesPage />
  </PageShell>
);

export async function getServerSideProps({ locale }) {
  const api = apiFactory(locale, JobsApiFactory);

  return {
    props: {
      dehydratedState: await getDehydratedState([
        {
          key: 'job-page',
          fn: async () => {
            let response = null;
            await api
              .apiJobPageGet()
              .then((result) => {
                response = result;
              })
              .catch((error) => {
                console.log(error);
              });
            return response.data;
          },
        },
      ]),
      meta: {
        title: 'meta.titles.jobs',
        description: 'meta.descriptions.jobs',
      },
    },
  };
}

export default Index;
